var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      attrs: { id: "version-card" },
    },
    [
      false && _vm.version.version === _vm.selectedBoard
        ? _c("div", { staticClass: "avatar-container" }, [
            _c("img", {
              staticClass: "avatar",
              attrs: {
                src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWTfCd8SFg2xp8ro3M3KM6PGq1zn8od1kAxNUjpnpbug&s",
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        !_vm.isEditName
          ? _c(
              "span",
              {
                staticStyle: {
                  "font-weight": "600",
                  color: "black",
                  "font-size": "14px",
                },
              },
              [_vm._v("v" + _vm._s(_vm.version.version))]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEditName,
              expression: "isEditName",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.editVersionName,
              expression: "editVersionName",
            },
          ],
          ref: "nameInput",
          staticClass: "update-name-input",
          attrs: {
            "text-type": "h6",
            "max-length": "128",
            "font-error": "false",
            "font-form-error": "true",
            "font-height": "small",
          },
          domProps: { value: _vm.editVersionName },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.editNameInputEnterClickHandler.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.editVersionName = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm.version.version === _vm.selectedBoard && !_vm.isEditName
          ? _c(
              "span",
              {
                staticStyle: {
                  padding: "2px 5px",
                  background: "#9ba6b3",
                  "font-size": "14px",
                  "font-weight": "600",
                  "border-radius": "4px",
                  color: "#fff",
                },
              },
              [_vm._v(_vm._s(_vm.$t("chatbotv2.preview")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.version.published && !_vm.isEditName
          ? _c(
              "span",
              {
                staticStyle: {
                  padding: "2px 5px",
                  background: "#1c57ff",
                  "border-radius": "3px",
                  color: "#fff",
                },
              },
              [_vm._v(_vm._s(_vm.$t("chatbotv2.published")))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.version.isDraft && !_vm.isEditName
          ? _c(
              "span",
              {
                staticStyle: {
                  padding: "2px 5px",
                  background: "#ffd98d",
                  "font-size": "14px",
                  "font-weight": "600",
                  "border-radius": "4px",
                  color: "#000",
                },
              },
              [_vm._v(_vm._s(_vm.$t("chatbotv2.draft")))]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.version.isDraft
          ? _c("div", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("chatbotv2.lastUpdate")) +
                  ": " +
                  _vm._s(_vm.$moment(_vm.version.publishDate).fromNow()) +
                  "\n        "
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "a-popover",
        {
          attrs: {
            trigger: "click",
            placement: "left",
            overlayClassName: "no-padding",
          },
          model: {
            value: _vm.popoverVisible,
            callback: function ($$v) {
              _vm.popoverVisible = $$v
            },
            expression: "popoverVisible",
          },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "list-wrapper" }, [
              _c("div", { staticClass: "list" }, [
                _vm.version.published || _vm.version.publishDate
                  ? _c(
                      "div",
                      {
                        staticClass: "list-item",
                        on: { click: _vm.reStoreClickHandler },
                      },
                      [
                        _c("md-icon", [_vm._v("history")]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("chatbotv2.restore")))]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.version.isDraft
                  ? _c(
                      "div",
                      {
                        staticClass: "list-item",
                        on: { click: _vm.editNameClickHandler },
                      },
                      [
                        _c("md-icon", [_vm._v("border_color")]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("chatbotv2.editName")))]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.version.isDraft
                  ? _c(
                      "div",
                      {
                        staticClass: "list-item",
                        on: { click: _vm.publishedClickHandler },
                      },
                      [
                        _c("md-icon", [_vm._v("send")]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.$t("chatbotv2.publish")))]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "be-icons",
              on: {
                click: function (e) {
                  _vm.popoverVisible = true
                  e.stopPropagation()
                },
              },
            },
            [_c("md-icon", [_vm._v("more_horiz")])],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.versionModal || _vm.restoreModalVisible
        ? _c(
            "a-modal",
            {
              attrs: {
                title: _vm.restoreModalVisible
                  ? _vm.$t("chatbotv2.restoreVersion")
                  : _vm.$t("chatbotv2.newVersion"),
                wrapClassName: "vertical-center-modal",
                okText: _vm.$t("message.ok"),
                cancelText: _vm.$t("message.cancel"),
              },
              on: {
                ok: _vm.modalOkHandler,
                cancel: function ($event) {
                  _vm.versionModal = false
                  _vm.restoreModalVisible = false
                },
              },
              model: {
                value: _vm.restoreModalVisible
                  ? _vm.restoreModalVisible
                  : _vm.versionModal,
                callback: function ($$v) {
                  _vm.restoreModalVisible
                    ? _vm.restoreModalVisible
                    : (_vm.versionModal = $$v)
                },
                expression:
                  "restoreModalVisible ? restoreModalVisible : versionModal",
              },
            },
            [
              !_vm.restoreModalVisible
                ? _c(
                    "a-form",
                    {
                      staticClass: "d-flex flex-column justify-content-center",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.publishHandler.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { placeholder: _vm.$t("chatbotv2.versionName") },
                        model: {
                          value: _vm.newVersionName,
                          callback: function ($$v) {
                            _vm.newVersionName = $$v
                          },
                          expression: "newVersionName",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { attrs: { id: "version-card-text" } }, [
                _vm.restoreModalVisible
                  ? _c("p", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("chatbotv2.restoreModalText")) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }